export default import.meta.ROLLDOWN_FILE_URL_xXZFm61IvYlyQERHZtyfgQ